export function formatCurrency(value, includeSign = true) {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return '—';
  }
  const formatted = Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 });
  return includeSign ? `$${formatted}` : formatted;
}

export function formatNumber(value, decimals = 2) {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return '—';
  }
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals });
}
